/* =============================================================================
   Asakusa — Wishlist maison (aucune app tierce)

   Stockage : localStorage, clé `asakusa_wishlist`, tableau de handles produit.
   On ne stocke QUE le handle : prix, stock et visuel sont re-rendus par Shopify
   à l'affichage, donc une wishlist vieille de six mois montre des données à jour.

   Rendu de la page wishlist : chaque produit est récupéré via
   /products/<handle>?view=card — un template alternatif qui ne renvoie que la
   carte. Pas de duplication de markup entre les grilles et la wishlist.

   Limite assumée : la liste vit dans le navigateur, elle ne suit pas le client
   d'un appareil à l'autre. Pour ça il faudrait la stocker sur le compte client
   (metafield customer) — possible plus tard sans changer cette interface.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'asakusa_wishlist';
  var store = null;
  try {
    store = window.localStorage;
    store.setItem('__asa_t', '1');
    store.removeItem('__asa_t');
  } catch (e) {
    store = null; // navigation privée / cookies bloqués : on dégrade en silence
  }

  function read() {
    if (!store) return [];
    try {
      var v = JSON.parse(store.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) { return []; }
  }

  function write(list) {
    if (!store) return;
    try { store.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('asakusa:wishlist:change', { detail: { list: list } }));
  }

  var Wishlist = {
    all: read,
    has: function (handle) { return read().indexOf(handle) !== -1; },
    add: function (handle) {
      var l = read();
      if (l.indexOf(handle) === -1) { l.unshift(handle); write(l); }
      return l;
    },
    remove: function (handle) {
      var l = read().filter(function (h) { return h !== handle; });
      write(l);
      return l;
    },
    toggle: function (handle) {
      return this.has(handle) ? (this.remove(handle), false) : (this.add(handle), true);
    },
    count: function () { return read().length; }
  };
  window.AsakusaWishlist = Wishlist;

  /* ---------- Compteurs dans le header / le drawer ---------- */
  function paintCount() {
    var n = Wishlist.count();
    document.querySelectorAll('[data-asa-wishcount]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  /* ---------- État des cœurs présents sur la page ---------- */
  function paintHearts(root) {
    (root || document).querySelectorAll('[data-asa-wish]').forEach(function (btn) {
      if (btn.classList.contains('asa-card__wish--remove')) return; // page wishlist : toujours « retirer »
      var on = Wishlist.has(btn.dataset.handle);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Retirer de ma wishlist' : 'Ajouter à ma wishlist');
      var label = btn.querySelector('[data-asa-wish-label]');   // bouton texte de la fiche produit
      if (label) label.textContent = on ? 'Dans ma wishlist' : 'Ajouter à ma wishlist';
    });
  }

  /* ---------- Délégation : un seul écouteur pour toute la page ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-asa-wish]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.dataset.handle;
    if (!handle) return;

    if (btn.classList.contains('asa-card__wish--remove')) {
      Wishlist.remove(handle);
      var card = btn.closest('[data-asa-card]');
      if (card) {
        card.style.transition = 'opacity .2s ease, transform .2s ease';
        card.style.opacity = '0';
        card.style.transform = 'scale(.97)';
        setTimeout(function () { card.remove(); refreshWishlistPage(); }, 200);
      }
      return;
    }

    var nowOn = Wishlist.toggle(handle);
    btn.classList.toggle('is-on', nowOn);
    btn.setAttribute('aria-pressed', nowOn ? 'true' : 'false');
    btn.setAttribute('aria-label', nowOn ? 'Retirer de ma wishlist' : 'Ajouter à ma wishlist');
    var lbl = btn.querySelector('[data-asa-wish-label]');
    if (lbl) lbl.textContent = nowOn ? 'Dans ma wishlist' : 'Ajouter à ma wishlist';
    if (nowOn) {
      btn.classList.remove('asa-pop-anim');
      void btn.offsetWidth;              // relance l'animation
      btn.classList.add('asa-pop-anim');
    }
  });

  document.addEventListener('asakusa:wishlist:change', function () { paintCount(); });

  /* =========================================================================
     Page wishlist
     ========================================================================= */
  var grid, empty, countEl, addAllBtn;

  function refreshWishlistPage() {
    if (!grid) return;
    var left = grid.querySelectorAll('[data-asa-card]').length;
    if (countEl) countEl.textContent = left + (left > 1 ? ' produits' : ' produit');
    if (empty) empty.hidden = left !== 0;
    if (grid) grid.hidden = left === 0;
    if (addAllBtn) addAllBtn.hidden = left === 0;
  }

  async function renderWishlistPage() {
    grid = document.querySelector('[data-asa-wishlist-grid]');
    if (!grid) return;
    empty = document.querySelector('[data-asa-wishlist-empty]');
    countEl = document.querySelector('[data-asa-wishlist-count]');
    addAllBtn = document.querySelector('[data-asa-wish-addall]');
    var loading = document.querySelector('[data-asa-wishlist-loading]');

    var handles = Wishlist.all();
    if (!handles.length) {
      if (loading) loading.hidden = true;
      refreshWishlistPage();
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var results = await Promise.all(handles.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    }));

    var stale = [];
    results.forEach(function (html, i) {
      if (!html) { stale.push(handles[i]); return; }   // produit supprimé ou dépublié
      var tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      var card = tmp.querySelector('[data-asa-card]');
      if (card) grid.appendChild(card); else stale.push(handles[i]);
    });

    // On purge les handles morts pour ne pas re-tenter à chaque visite
    if (stale.length) write(handles.filter(function (h) { return stale.indexOf(h) === -1; }));

    if (loading) loading.hidden = true;
    refreshWishlistPage();
    paintHearts(grid);
  }

  /* ---------- « Ajouter au panier » depuis la wishlist ---------- */
  document.addEventListener('click', async function (e) {
    var one = e.target.closest('[data-asa-wish-add]');
    var all = e.target.closest('[data-asa-wish-addall]');
    if (!one && !all) return;
    e.preventDefault();

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var items = [];
    if (one) {
      items = [{ id: Number(one.dataset.variant), quantity: 1 }];
      one.setAttribute('aria-busy', 'true');
    } else {
      document.querySelectorAll('[data-asa-wish-add]').forEach(function (b) {
        items.push({ id: Number(b.dataset.variant), quantity: 1 });
      });
      all.setAttribute('aria-busy', 'true');
    }
    if (!items.length) return;

    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      });
      if (res.ok) {
        var cart = await (await fetch(root + 'cart.js')).json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true, detail: { baseEvent: 'variant:add', cart: cart }
        }));
        var btn = one || all;
        var old = btn.textContent;
        btn.textContent = 'Ajouté ✓';
        setTimeout(function () { btn.textContent = old; }, 1600);
      }
    } catch (err) { /* on ne casse rien : le client peut passer par la fiche produit */ }
    finally { (one || all).removeAttribute('aria-busy'); }
  });

  /* ---------- Démarrage ---------- */
  function boot() {
    paintCount();
    paintHearts();
    renderWishlistPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
